import axios from 'axios';

const defSeason = 2016;

function getPlayerList(season = defSeason) {
  const url = `${process.env.PUBLIC_URL}/data/${season}/shooters.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getPlayerStats(playerId, season = defSeason) {
  const url = `${process.env.PUBLIC_URL}/data/${season}/player-stats/${playerId}.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

function getPlayerShots(playerId, season = 'all') {
  const url = `${process.env.PUBLIC_URL}/data/${season}/player-shots/${playerId}.json`;

  return axios.get(url)
    .then(
      responce => {
        return responce.data;
      },
      error => {
        console.log('An error occured.', error);
        return [];
      }
    )
}

export default {
  getPlayerList,
  getPlayerStats,
  getPlayerShots
}


// WEBPACK FOOTER //
// ./src/redux/services/data-service.js